import React, { useState, useEffect } from 'react';
import { Button, Grid, Typography, Box, Chip } from '@mui/material';
import { AvailabilityModal } from './AnalystAvailabilityModal';
import { App_Service } from '../../../../redux/app/app.services';
import httpCommon from '../../../../http-common';

const fetchAnalystsData = async () => {
  // Mocked data for now. Replace with your actual fetch call later.
  const response = httpCommon.get(`/v1/qc/analyst_availability`);
  const data = (await response).data;
  // console.log({ data });
  return data?.analysts || [];
  // return [
  //   { "analyst_id": "Ram", "availability": true },
  //   { "analyst_id": "Shyam", "availability": true },
  //   { "analyst_id": "Rohan", "availability": false },
  //   { "analyst_id": "Mohan", "availability": true },
  //   { "analyst_id": "Sohan", "availability": false },
  //   { "analyst_id": "Aman", "availability": true },
  //   { "analyst_id": "Vivek", "availability": false },
  //   { "analyst_id": "Vikram", "availability": true },
  //   { "analyst_id": "Aditya", "availability": true },
  //   { "analyst_id": "Abhishek", "availability": false },
  //   { "analyst_id": "Suresh", "availability": true },
  //   { "analyst_id": "Ramesh", "availability": false },
  //   { "analyst_id": "Rajesh", "availability": true },
  //   { "analyst_id": "Sunil", "availability": true },
  //   { "analyst_id": "Sunny", "availability": false },
  //   { "analyst_id": "Rishi", "availability": true },
  //   { "analyst_id": "Kunal", "availability": false },
  //   { "analyst_id": "Karan", "availability": true },
  //   { "analyst_id": "Arjun", "availability": true },
  //   { "analyst_id": "Aryan", "availability": false },
  //   { "analyst_id": "Nikhil", "availability": true },
  //   { "analyst_id": "Nitin", "availability": false },
  //   { "analyst_id": "Anil", "availability": true },
  //   { "analyst_id": "Ashish", "availability": true },
  //   { "analyst_id": "Amit", "availability": false },
  //   { "analyst_id": "Pranav", "availability": true },
  //   { "analyst_id": "Pankaj", "availability": false },
  //   { "analyst_id": "Vinod", "availability": true },
  //   { "analyst_id": "Vijay", "availability": true },
  //   { "analyst_id": "Varun", "availability": false }
  // ];
};

const AnalystMatrix = () => {
  const [analysts, setAnalysts] = useState([]);

  // State to manage the modal visibility and selected analyst
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAnalyst, setSelectedAnalyst] = useState(null);

  const openModal = (analyst) => {
    setSelectedAnalyst(analyst);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };


  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchAnalystsData();
      setAnalysts(data.map((d, idx) => {
        return {
          ...d,
          // analyst_id: `${d.analyst_id}_${idx}`
          // analyst_id: `${d.analyst_id}_${idx}`
        };
      }));
    };
    fetchData();
  }, []);

  const toggleAvailability = async (analystId, availability_status) => {
    const updatedAnalysts = analysts.map(analyst =>
      analyst.analyst_id === analystId
        ? { ...analyst, availability: availability_status }
        : analyst
    );
    // const json_array = JSON.stringify(updatedAnalysts);
    try {
      const form_data = new FormData();
      form_data.append("analyst_id", analystId);
      form_data.append("availability", availability_status);
      await App_Service.patch_analyst(form_data);
      setAnalysts(updatedAnalysts);
    } catch (error) {
      console.log({ error });
    }
  };

  // useEffect(() => {
  //   console.log({ analysts });
  // }, [analysts]);

  return (
    <Box>
      <Box className="flex items-center justify-between flex-wrap">
        <Typography variant="h4" gutterBottom align="left">
          Analyst Availability Matrix
        </Typography>
        <Box className="flex gap-2 items-center">
          Legend:
          {/* <span style={{ marginLeft: '10px', color: 'green' }}>Available</span> */}
          <Chip label="Available" variant='filled' color='success' />
          <Chip label="Unavailable" color="error" />
        </Box>
      </Box>
      {/* <Box mb={2}>
      </Box> */}
      <Grid container spacing={1}>
        {analysts.map(analyst => (
          <Grid item xs={4} md={1} key={analyst.analyst_id}>
            <Button
              fullWidth
              variant="contained"
              color={analyst.availability ? "success" : "error"}
              onClick={() => openModal(analyst)}
              size="medium"
              style={{ textTransform: 'none', height: "90px" }}
            >
              {analyst.analyst_id?.split("_")?.join(" ")}
            </Button>
          </Grid>
        ))}
      </Grid>
      {/* Modal component */}
      <AvailabilityModal
        key={`availability_modal`}
        analyst={selectedAnalyst}
        onClose={closeModal}
        open={isModalOpen}
        toggleAvailability={toggleAvailability}
      />
    </Box>
  );
};

export default AnalystMatrix;
